import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import { Button, Typography } from '@mui/material';
import { RedirectToVP } from '@utils/route';

const SuccessStep = () => {
    const handleBack = () => RedirectToVP();

    return (
        <div className="w-full pt-10 pb-16">
            <div className="flex flex-col max-w-[365px] items-center mx-auto gap-14">
                <div className="flex flex-col items-center gap-7">
                    <div className="flex items-center justify-center size-24 rounded-full border-2">
                        <CheckRoundedIcon className="size-10" />
                    </div>
                    <div className="flex flex-col items-center gap-7">
                        <Typography className="font-museo" variant="h3">
                            Success
                        </Typography>
                        <Typography className="font-inter text-center text-2xl leading-9" fontWeight={400}>
                            Your application Form was <br /> successfully submitted
                        </Typography>
                    </div>
                </div>
                <Button className="rounded-sm" startIcon={<SpaceDashboardOutlinedIcon />} onClick={handleBack}>
                    BACK TO OVERVIEW
                </Button>
            </div>
        </div>
    );
};

export { SuccessStep };
